import CoverButton from "./CoverButton";
import Avatar from "./Avatar";

export default {
  CoverButton,
  Avatar
};
